import React from "react";

const Pagination = ({ totalPages, currentPage, onPageChange }) => {
  const maxPageButtons = 3;
  const getPageRange = () => {
    const half = Math.floor(maxPageButtons / 2);
    let start = Math.max(1, currentPage - half);
    let end = Math.min(totalPages, currentPage + half);
    if (start === 1) {
      end = Math.min(totalPages, maxPageButtons);
    }
    if (end === totalPages) {
      start = Math.max(1, totalPages - maxPageButtons + 1);
    }
    return { start, end };
  };

  const { start, end } = getPageRange();

  return (
    <div className="flex justify-end mt-6 space-x-2">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        className={`px-3 py-1 rounded ${
          currentPage === 1
            ? "bg-gray-300 text-gray-500 cursor-not-allowed"
            : "bg-gray-200 text-gray-600 hover:bg-gray-300"
        }`}
        disabled={currentPage === 1}
      >
        Prev
      </button>
      {start > 1 && (
        <>
          <button
            onClick={() => onPageChange(1)}
            className={`px-3 py-1 rounded ${
              currentPage === 1
                ? "bg-[#1E6BDD] text-white"
                : "bg-gray-200 text-gray-600 hover:bg-gray-300"
            }`}
          >
            1
          </button>
          {start > 2 && <span className="px-3 py-1 text-gray-600">...</span>}
        </>
      )}
      {Array.from({ length: end - start + 1 }, (_, idx) => start + idx).map(
        (page) => (
          <button
            key={page}
            onClick={() => onPageChange(page)}
            className={`px-3 py-1 rounded ${
              currentPage === page
                ? "bg-[#1E6BDD] text-white"
                : "bg-gray-200 text-gray-600 hover:bg-gray-300"
            }`}
          >
            {page}
          </button>
        )
      )}
      {end < totalPages - 1 && (
        <>
          <span className="px-3 py-1 text-gray-600">...</span>
          <button
            onClick={() => onPageChange(totalPages)}
            className={`px-3 py-1 rounded ${
              currentPage === totalPages
                ? "bg-[#1E6BDD] text-white"
                : "bg-gray-200 text-gray-600 hover:bg-gray-300"
            }`}
          >
            {totalPages}
          </button>
        </>
      )}
      <button
        onClick={() => onPageChange(currentPage + 1)}
        className={`px-3 py-1 rounded ${
          currentPage === totalPages
            ? "bg-gray-300 text-gray-500 cursor-not-allowed"
            : "bg-gray-200 text-gray-600 hover:bg-gray-300"
        }`}
        disabled={currentPage === totalPages}
      >
        Next
      </button>
    </div>
  );
};

export default Pagination;
